import React, { useContext, useEffect, useRef } from 'react';
import { Col } from 'react-bootstrap';
import { NavBarContext } from '.';

export default function({
  eventKey, title, quantity, hiddenEmpty
}){
  const {addNavItem, removeNavItem} = useContext(NavBarContext)
  const ref = useRef();

  useEffect(()=>{
    let id = null;
    if(addNavItem && !hiddenEmpty){
      id = addNavItem(ref, quantity);
    } else if(hiddenEmpty && quantity){
      id = addNavItem(ref, quantity);
    }

    return ()=>{
      if(id){
        removeNavItem(id);
      }
    };
  },[addNavItem, removeNavItem, ref, quantity, hiddenEmpty]);

  if(hiddenEmpty && !quantity){
    return <></>;
  }

  return (
    <div ref={ref} className="col-nav-bar-item" data-event-key={eventKey}>
      <div className="nav-bar-item">{title}</div>
      {quantity!==null?<span className="badge badge-light nav-bar-quantity">{quantity}</span>:<></>}
    </div>
  );
}